const { __esModule } = require("luxon");
const { DateTime } = require("luxon");

const INITIAL_DATE_TIME = {
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0,
};

const getSlots = (startTime, endTime, interval = 30, day = new Date()) => {
  const startOfDay = DateTime.fromJSDate(day);
  let start = startOfDay.set({
    ...INITIAL_DATE_TIME,
    hour: startTime,
  });
  const end = startOfDay.set({
    ...INITIAL_DATE_TIME,
    hour: endTime,
  });
  const slots = [];
  while (start < end) {
    const slotEnd = start.plus({ minute: interval });
    slots.push({ start, end: slotEnd, available: true });
    start = slotEnd;
  }
  return slots;
};

module.exports = {
  INITIAL_DATE_TIME,
  getSlots,
};
